const formatDateString = (dateString: string): string => {
	const date = new Date(dateString)
	// Use Intl.DateTimeFormat to format the date in dd/mm/yyyy
	const formatter = new Intl.DateTimeFormat("en-GB", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	})

	// Format the date
	const formattedDate = formatter.format(date)

	return formattedDate
}


export default formatDateString